import { useEffect, useState } from "react";
import {
  classNames,
  formatDateWithTime,
  isReadOnlyUser,
} from "../../../shared/utility";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import WipOutgoingSubTable1 from "./outgoingSubtables/WipOutgoingSubTable1";
import TraceableLotNumber from "../../controls/TraceableLotNumber";

export default function OutgoingWipItemsTableComponent(props) {
  const {
    isEdit,
    loading,
    values,
    openSlideForManufacturedItemDetails,
    onAskDeleteWipOutputItem,
    openAddPriceGroupModal,
    setOutgoingSelectedItems,
    outgoingSelectedItems,
    outgoingDeleteSelectedItems = [],
    setOutgoingDeleteSelectedItems = () => {},
    askDeleteSelectedOutgoingItems,
    calculateCostForWipOutgoingItems,
    fetchOutgoingRowDetails,
    outgoingLoadingRows,
    outgoingRowDetails,
    fetchOutgoingSubRowDetails,
    outgoingSubRowDetails,
    outgoingSubLoadingRows,
    setOutgoingRowDetails,
    setOutgoingSubRowDetails,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);
  const allowExpansion = () => {
    return true;
  };

  const onRowExpand = (event) => {
    const rowData = event.data;
    if (!outgoingRowDetails[rowData.unique_id]) {
      fetchOutgoingRowDetails(rowData);
    }
  };

  const rowExpansionTemplate = (data) => {
    return (
      <WipOutgoingSubTable1
        data={data}
        outgoingLoadingRows={outgoingLoadingRows}
        outgoingRowDetails={outgoingRowDetails}
        fetchOutgoingSubRowDetails={fetchOutgoingSubRowDetails}
        outgoingSubRowDetails={outgoingSubRowDetails}
        outgoingSubLoadingRows={outgoingSubLoadingRows}
        openSlideForManufacturedItemDetails={
          openSlideForManufacturedItemDetails
        }
        onAskDeleteWipOutputItem={onAskDeleteWipOutputItem}
        outgoingDeleteSelectedItems={outgoingDeleteSelectedItems}
        setOutgoingDeleteSelectedItems={setOutgoingDeleteSelectedItems}
      />
    );
  };

  const bodyProductName = (item) => {
    return (
      <p>
        {item.product_name} <br />
        {item.plu}
        {Number(item.is_deleted) === 1 && (
          <span className="ml-2 text-xs font-semibold text-red-700">DELETED</span>
        )}
      </p>
    );
  };

  const bodyParentTotalWeight = (item) => {
    return <p>{item.total_weight_in_kg} kg</p>;
  };

  const bodyParentTotalPieces = (item) => {
    return <p>{item.total_pieces} pieces</p>;
  };

  const itemCostPercentage = (item) => {
    return <p>{item.production_cost_percentage}%</p>;
  };

  const itemTotalCostInDollars = (item) => {
    return <p>${item.total_cost}</p>;
  };

  const isReadOnly = isReadOnlyUser();

  return (
    <div className="flow-root">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 space-y-2">
          <div className="w-full flex">
            <h3 className="text-lg leading-6 font-medium text-gray-900 flex-grow">
              Outgoing items
            </h3>
            {!isReadOnly && (
              <button
                className={
                  isEdit
                    ? "rounded-md bg-cyan-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cyan-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-700"
                    : "hidden"
                }
                onClick={openAddPriceGroupModal}
              >
                Add price group
              </button>
            )}
            {!isReadOnly && (
              <button
                className={
                  isEdit && askDeleteSelectedOutgoingItems
                    ? "rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 ml-2"
                    : "hidden"
                }
                onClick={askDeleteSelectedOutgoingItems}
              >
                Delete selected ({(outgoingDeleteSelectedItems || []).length})
              </button>
            )}
            <button
              className={
                isEdit
                  ? "rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-700 ml-2"
                  : "hidden"
              }
              onClick={() => {
                calculateCostForWipOutgoingItems();
                setExpandedRows(false);
                setOutgoingRowDetails({});
                setOutgoingSubRowDetails({});
              }}
            >
              Calculate cost
            </button>
          </div>

          {loading ? (
            <div>
              <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                <div className="animate-pulse flex space-x-4">Loading</div>
              </div>
            </div>
          ) : (
            <div className="overflow-hidden card-custom bg-white">
              <DataTable
                value={values.outgoing_items}
                expandedRows={expandedRows}
                onRowToggle={(e) => {
                  setExpandedRows(e.data);
                }}
                onRowExpand={onRowExpand}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="unique_id"
                rowClassName={(item) => ({ "wip-deleted-output": Number(item.is_deleted) === 1 })}
                isDataSelectable={(event) => Number(event.data.is_deleted) !== 1}
                tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm wip-outgoing-items-table"
                cellClassName="p-2 border-1-bottom-gray text-sm"
                selectionMode="checkbox"
                selection={outgoingSelectedItems}
                onSelectionChange={(e) => setOutgoingSelectedItems(e.value)}
              >
                <Column
                  selectionMode="multiple"
                  headerStyle={{ width: "1px" }}
                ></Column>
                <Column
                  header="Product Name"
                  body={bodyProductName}
                  style={{ width: "25%" }}
                />
                <Column
                  header="Lot Number"
                  body={(item) => (
                    <TraceableLotNumber
                      lotNumber={item.lot_number}
                      traceType="manufactured"
                    />
                  )}
                  style={{ width: "15%" }}
                />
                <Column
                  header="Carton Count"
                  field="carton_count"
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Total Weight (kg)"
                  body={bodyParentTotalWeight}
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Total Pieces"
                  body={bodyParentTotalPieces}
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Cost %"
                  body={itemCostPercentage}
                  style={{ textAlign: "right" }}
                />
                <Column
                  header="Cost $"
                  body={itemTotalCostInDollars}
                  style={{ textAlign: "right" }}
                />
                <Column expander={allowExpansion} style={{ width: "6%" }} />
              </DataTable>
              {values.outgoing_info ? (
                <div className="p-4 space-y-3">
                  <div className="flex justify-end gap-4">
                    <p className="text-md font-bold">
                      Total cartons: {values.outgoing_info.carton_count}
                    </p>
                    <p>
                      Total weight: {values.outgoing_info.total_weight_in_kg} kg
                    </p>
                    <p>
                      Total pieces: {values.outgoing_info.total_pieces} pieces
                    </p>
                  </div>
                  <div className="flex justify-end gap-4">
                    <p
                      className={classNames(
                        values.outgoing_info.total_cost_percentage > 100
                          ? "text-red-600"
                          : parseFloat(
                                values.outgoing_info.total_cost_percentage,
                              ) === parseFloat(100)
                            ? "text-green-600"
                            : null,
                        "text-md font-bold",
                      )}
                    >
                      Total cost percentage:{" "}
                      {values.outgoing_info.total_cost_percentage}%
                    </p>
                    <p>Total cost: ${values.outgoing_info.total_cost}</p>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
